import { render } from "./web-login.vue?vue&type=template&id=5e88c726&scoped=true"
import script from "./web-login.vue?vue&type=script&lang=js"
export * from "./web-login.vue?vue&type=script&lang=js"

import "./web-login.vue?vue&type=style&index=0&id=5e88c726&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e88c726"]])

export default __exports__